/* WICK 14/10/2026 v3 (cambio rapido entre modelos con la hoja abierta) · Elegir talla desde el listado, sin entrar en la ficha.
   - Movil: boton "+" en la foto -> se abre una hoja desde abajo con las tallas en cuadricula (botones grandes).
   - Escritorio: al pasar el raton por la foto aparecen las tallas en una barra compacta.
   - Un toque en una talla = se anade al carrito y se abre el carrito lateral.
   - Si el producto tiene varias variantes SIEMPRE se elige talla (nunca se anade una talla al azar).
   - Tallas agotadas tachadas. Solo los productos de una unica variante se anaden directamente con el "+".
   - Las lineas anadidas asi llevan la propiedad oculta _wk_source = "card-quick-size" para medirlo.
   - Tambien oculta el globo flotante de Loyalty (Joy) en toda la web: Loyalty queda solo en el menu. */
(function () {
  if (window.__wkQs) return; window.__wkQs = true;
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = {
    es: { add: 'Añadido al carrito ✓', err: 'No se pudo añadir', so: 'Agotado', pick: 'Elige tu talla', close: 'Cerrar' },
    pt: { add: 'Adicionado ao carrinho ✓', err: 'Não foi possível adicionar', so: 'Esgotado', pick: 'Escolha o tamanho', close: 'Fechar' },
    en: { add: 'Added to cart ✓', err: 'Could not add', so: 'Sold out', pick: 'Select your size', close: 'Close' }
  };
  var L = T[lang] || T.en;
  var SIZE_RE = /size|talla|tama|taille|taglia|größe|maat|rozmiar|storlek|størrelse/i;
  var COLOR_RE = /colou?r|cor\b|couleur|colore|farbe|kleur/i;
  var cache = {};
  var PLUS = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var mqDesk = window.matchMedia ? window.matchMedia('(hover: hover) and (min-width: 750px)') : { matches: false };

  function prodUrl(card) {
    var a = card.querySelector('.card__heading a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var u = a.getAttribute('href').split('?')[0].split('#')[0];
    if (/gift-card|giftcard|tarjeta-regalo/i.test(u)) return null;
    return u;
  }
  function load(url) {
    if (!cache[url]) cache[url] = fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw 0; return r.json(); });
    return cache[url];
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* "EU 37 / US 5" -> linea grande "EU 37" y pequena "US 5" */
  function label(val) {
    var p = String(val).split(/\s*\/\s*/);
    return '<span class="wk-qs__l1">' + esc(p[0]) + '</span>' + (p[1] ? '<span class="wk-qs__l2">' + esc(p.slice(1).join(' / ')) + '</span>' : '');
  }
  /* Analiza el producto: lista de tallas {val, id} o variante unica */
  function analyse(p) {
    var vs = p.variants || [];
    if (!p.available) return { soldout: true };
    if (vs.length < 2) { var v1 = vs.filter(function (x) { return x.available; })[0]; return { one: v1 ? v1.id : '' }; }
    var opts = (p.options || []).map(function (o, i) { return typeof o === 'string' ? { name: o, i: i } : { name: o.name, i: i, values: o.values }; });
    var si = -1, i;
    for (i = 0; i < opts.length; i++) { if (SIZE_RE.test(opts[i].name || '')) { si = i; break; } }
    if (si < 0) {
      var best = -1, bestN = -1;
      for (i = 0; i < opts.length; i++) {
        if (COLOR_RE.test(opts[i].name || '')) continue;
        var n = {}; vs.forEach(function (v) { n[v['option' + (i + 1)]] = 1; });
        var c = Object.keys(n).length; if (c > bestN) { bestN = c; best = i; }
      }
      si = best >= 0 ? best : 0;
    }
    var key = 'option' + (si + 1), order = [], map = {};
    vs.forEach(function (v) {
      var val = v[key]; if (val == null) return;
      if (!(val in map)) { map[val] = null; order.push(val); }
      if (v.available && !map[val]) map[val] = v.id;
    });
    var multi = opts.length > 1;
    return { sizes: order.map(function (val) { return { val: val, id: map[val] }; }), name: (opts[si] && opts[si].name) || '', multi: multi };
  }
  function sizesHTML(a) {
    return a.sizes.map(function (s) {
      return s.id ? '<button type="button" class="wk-qs__sz" data-v="' + s.id + '">' + label(s.val) + '</button>'
                  : '<button type="button" class="wk-qs__sz" disabled aria-label="' + esc(s.val) + ' · ' + L.so + '">' + label(s.val) + '</button>';
    }).join('');
  }

  /* ---------- Hoja inferior (movil) ---------- */
  var sheet, sheetBody, sheetTitle, sheetMsg, sheetQ;
  function ensureSheet() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'wk-qsheet'; sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML = '<div class="wk-qsheet__bg" data-close></div><div class="wk-qsheet__box" role="dialog" aria-modal="true">' +
      '<div class="wk-qsheet__head"><div><p class="wk-qsheet__pick">' + L.pick + '</p><p class="wk-qsheet__title"></p></div>' +
      '<button type="button" class="wk-qsheet__x" data-close aria-label="' + L.close + '"><svg viewBox="0 0 16 16" width="18" height="18" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6"/></svg></button></div>' +
      '<div class="wk-qsheet__grid"></div><div class="wk-qs__msg wk-qsheet__msg" aria-live="polite"></div></div>';
    document.body.appendChild(sheet);
    sheetBody = sheet.querySelector('.wk-qsheet__grid'); sheetTitle = sheet.querySelector('.wk-qsheet__title'); sheetMsg = sheet.querySelector('.wk-qsheet__msg');
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { closeSheet(); return; }
      var sz = e.target.closest('.wk-qs__sz');
      if (sz && !sz.disabled) add(sz.dataset.v, sz, sheetMsg, function () { setTimeout(closeSheet, 700); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }
  function openSheet(q, a) {
    ensureSheet();
    if (sheetQ && sheetQ !== q) sheetQ.classList.remove('is-active');
    sheetQ = q; q.classList.add('is-active');
    sheetTitle.textContent = q.dataset.title || '';
    sheetBody.innerHTML = sizesHTML(a);
    sheetBody.classList.toggle('is-long', a.sizes.some(function (s) { return String(s.val).length > 5; }));
    sheetMsg.textContent = ''; sheetMsg.classList.remove('is-err');
    sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false');
  }
  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true');
    if (sheetQ) { sheetQ.classList.remove('is-active'); sheetQ = null; }
  }

  /* ---------- Barra en la tarjeta (escritorio) ---------- */
  function buildBar(q, a) {
    if (q.dataset.bar) return; q.dataset.bar = '1';
    var panel = q.querySelector('.wk-qs__panel');
    if (a.soldout) { panel.innerHTML = '<div class="wk-qs__msg">' + L.so + '</div>'; return; }
    if (a.sizes) {
      panel.innerHTML = '<div class="wk-qs__sizes' + (a.sizes.some(function (s) { return String(s.val).length > 5; }) ? ' is-long' : '') + '" role="group" aria-label="' + L.pick + '">' + sizesHTML(a) + '</div><div class="wk-qs__msg" aria-live="polite"></div>';
    } else { panel.innerHTML = '<div class="wk-qs__msg" aria-live="polite"></div>'; q.classList.add('wk-qs--one'); }
  }
  function prepare(q) {
    if (!q._p) q._p = load(q.dataset.url).then(function (p) { q._a = analyse(p); if (p.title && !q.dataset.title) q.dataset.title = p.title; return q._a; }).catch(function () { q._p = null; throw 0; });
    return q._p;
  }
  function inject(card) {
    if (card.dataset.wkQs) return; card.dataset.wkQs = '1';
    var inner = card.querySelector('.card__inner'); if (!inner || !inner.querySelector('.card__media')) return;
    var url = prodUrl(card); if (!url) return;
    var h = card.querySelector('.card__heading a');
    var q = document.createElement('div');
    q.className = 'wk-qs'; q.dataset.url = url; q.dataset.title = h ? h.textContent.trim() : '';
    q.innerHTML = '<div class="wk-qs__panel"></div><button type="button" class="wk-qs__open" aria-label="' + L.pick + '" aria-haspopup="dialog">' + PLUS + '</button>';
    inner.appendChild(q);
    card.addEventListener('mouseenter', function () {
      if (!mqDesk.matches) return;
      q.classList.remove('is-closed');
      prepare(q).then(function (a) { buildBar(q, a); }).catch(function () {});
    });
  }
  function scan() { document.querySelectorAll('.product-card-wrapper').forEach(inject); }

  function add(id, btn, msg, after) {
    if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
    if (!id) { if (msg) { msg.textContent = L.so; msg.classList.add('is-err'); } return; }
    btn.classList.add('is-busy'); btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1, properties: { _wk_source: 'card-quick-size', _wk_from: location.pathname } }] };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-busy'); btn.disabled = false;
      if (res.status && res.description) { if (msg) { msg.textContent = res.description || L.err; msg.classList.add('is-err'); } return; }
      btn.classList.add('is-done'); if (msg) msg.textContent = L.add;
      setTimeout(function () { btn.classList.remove('is-done'); if (msg) msg.textContent = ''; }, 1500);
      if (after) after();
      if (drawer && drawer.renderContents && res.sections) { try { res.id = id; drawer.classList.remove('is-empty'); drawer.renderContents(res); return; } catch (e) {} }
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    }).catch(function () { btn.classList.remove('is-busy'); btn.disabled = false; if (msg) { msg.textContent = L.err; msg.classList.add('is-err'); } });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.wk-qs');
    if (!q) { if (sheet && sheet.classList.contains('is-open') && !e.target.closest('.wk-qsheet__box')) closeSheet(); return; }
    e.preventDefault(); e.stopPropagation();
    var msg = q.querySelector('.wk-qs__msg');
    var sz = e.target.closest('.wk-qs__sz');
    if (sz) { if (!sz.disabled) add(sz.dataset.v, sz, msg, function () { setTimeout(function () { q.classList.add('is-closed'); }, 900); }); return; }
    var op = e.target.closest('.wk-qs__open');
    if (!op) return;
    op.classList.add('is-busy');
    prepare(q).then(function (a) {
      op.classList.remove('is-busy');
      if (a.soldout) { buildBar(q, a); q.classList.add('is-open'); return; }
      if (a.sizes) {
        if (mqDesk.matches) { buildBar(q, a); q.classList.remove('is-closed'); return; }
        if (sheetQ === q && sheet.classList.contains('is-open')) { closeSheet(); return; }
        openSheet(q, a); return;
      }
      buildBar(q, a); add(a.one, op, q.querySelector('.wk-qs__msg'));
    }).catch(function () { op.classList.remove('is-busy'); });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(); hideLoyalty(); }, 80); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Globo flotante de Loyalty (Joy): fuera en toda la web, Loyalty solo en el menu ---------- */
  function hideLoyalty() {
    var c = document.querySelectorAll('[id*="joy" i],[class*="joy" i],iframe[src*="joy" i],[id*="loyalty" i],[class*="loyalty" i]');
    for (var i = 0; i < c.length; i++) {
      var root = c[i];
      if (root.closest('header, .header-wrapper, menu-drawer, .menu-drawer, main, footer, .footer, .wk-keep-joy')) continue;
      var list = [root].concat([].slice.call(root.querySelectorAll('*'), 0, 60));
      for (var k = 0; k < list.length; k++) {
        var el = list[k], st = getComputedStyle(el);
        if (st.position !== 'fixed') continue;
        var r = el.getBoundingClientRect();
        if (r.width <= 260 && r.height <= 140 && r.bottom > window.innerHeight * 0.5) { el.style.setProperty('display', 'none', 'important'); el.setAttribute('data-wk-hidden', 'loyalty'); }
      }
    }
  }
  hideLoyalty(); setTimeout(hideLoyalty, 1500); setTimeout(hideLoyalty, 4000);
})();
